import React from 'react';
import {FormPane} from "../../../components/FormZero/PageComponents/FormPane/FormPane";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Card,
    CardHeader, Checkbox,
    List,
    ListItem,
    ListItemButton, ListItemIcon,
    ListItemText,
    TextField,
    Typography
} from "@mui/material";
import {Subject} from 'rxjs';
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Divider} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";

function SpeciesPicklistDialog(props: { filteredLoads: any; }) {
    const {filteredLoads} = props;

    const [filterValue, setFilterValue] = React.useState("");
    const calculateSpeciesList = (filteredLoads: any[] | null | undefined) => {
        if (filteredLoads === undefined || filteredLoads === null) return [];
        let species: { MaterialDescription: any; OrderdQty: any; }[] = [];
        filteredLoads.forEach((load: { deliveries: any[]; }) => {
            load.deliveries.forEach((delivery: { items: any[]; }) => {
                delivery.items.forEach((item: { MaterialDescription: any; OrderdQty: any; }) => {
                    species.push({MaterialDescription: item.MaterialDescription, OrderdQty: item.OrderdQty})
                });
            });
        });
        return species;
    };
    const [speciesList, setSpeciesList] = React.useState<any>(calculateSpeciesList(filteredLoads));
    const [activatedLoads, setActivatedLoads] = React.useState<any>([]);
    React.useEffect(() => {
        console.log(filteredLoads);
        setSpeciesList(calculateSpeciesList(filteredLoads));
    }, [filteredLoads]);

    const [isOpen, setOpen] = React.useState(false);

    return (<>
        <Button fullWidth={true} variant={'contained'} color={"primary"} onClick={() => setOpen(true)}>Species
            Picklist</Button>
        <Dialog
            open={isOpen}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth={"xl"}
        >
            <DialogTitle id="alert-dialog-title">
                Species Picklist
            </DialogTitle>
            <DialogContent style={{height: '400px', textAlign: 'center'}}>
                <DialogContentText id="alert-dialog-description">
                    Have ability to search list of species, and than add them to the ones you are about to print.
                </DialogContentText>
                <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
                    <div style={{display: 'flex', flexDirection: 'row', gap: '1rem'}}>
                        {/*<pre>{JSON.stringify(speciesList, undefined, 4)}</pre>*/}
                        <Card variant="outlined" style={{flexGrow: 1}} elevation={1}>
                            <CardHeader sx={{px: 2, py: 1}} title={"Available"}/>
                            <div style={{padding: '0.5rem'}}>
                                <TextField size={"small"} fullWidth={true} label={"Filter"} value={filterValue}
                                           onChange={(e) => setFilterValue(e.target.value)}/>
                            </div>
                            <Divider/>
                            <List sx={{width: 300, height: 230, bgcolor: 'background.paper', overflow: 'auto',}} dense
                                  component="div" role="list">
                                {speciesList.filter((s: any) => activatedLoads.indexOf(s) === -1).filter((s: { MaterialDescription: string; }) => {
                                    if (filterValue !== "") {
                                        // filter it
                                        return s.MaterialDescription.toLowerCase().indexOf(filterValue.toLowerCase()) > -1;
                                    } else {
                                        return true;
                                    }
                                }).map((value : any) => {
                                    const labelId = `transfer-list-all-item-${value}-label`;
                                    return (
                                        <ListItem
                                            key={value.id}
                                            role="listitem"
                                        >
                                            <ListItemText id={labelId} primary={`${value.MaterialDescription}`}/>&nbsp;
                                            <Button variant={'contained'} color={"secondary"}
                                                    onClick={() => {
                                                        // removeUserFromGroup(value.id).then()
                                                        setActivatedLoads((l: any) => [...l, value]);
                                                    }}>
                                                <FontAwesomeIcon icon={faArrowRight}/>
                                            </Button>
                                        </ListItem>
                                    );
                                })}
                                <ListItem/>
                            </List>
                        </Card>

                        <Card variant="outlined" style={{flexGrow: 1}} elevation={1}>
                            <CardHeader sx={{px: 2, py: 1}} title={"Selected For Print"}/>
                            <Divider/>
                            <List sx={{width: 300, height: 230, bgcolor: 'background.paper', overflow: 'auto',}} dense
                                  component="div" role="list">
                                {speciesList.filter((s: any) => activatedLoads.indexOf(s) > -1).map((value: { id: React.Key | null | undefined; MaterialDescription: any; }) => {
                                    const labelId = `transfer-list-all-item-${value}-label`;
                                    return (
                                        <ListItem
                                            key={value.id}
                                            role="listitem"
                                        >
                                            <Button variant={'contained'} color={"error"}
                                                    onClick={() => {
                                                        // addUserToGroup(value.id).then()
                                                        setActivatedLoads((l: any[]) => l.filter((s: any) => s !== value));
                                                    }}>
                                                <FontAwesomeIcon icon={faArrowLeft}/>
                                            </Button>&nbsp;<ListItemText style={{textAlign: "right"}}
                                                                         id={labelId}
                                                                         primary={`${value.MaterialDescription}`}/>
                                        </ListItem>
                                    );
                                })}
                                <ListItem/>
                            </List>
                        </Card>
                    </div>
                </div>

            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>Close</Button>
                <Button onClick={() => setOpen(false)}>Print</Button>
            </DialogActions>
        </Dialog>
    </>)
}

function LoadPicklistDialog(props: { filteredLoads: any; }) {
    const {filteredLoads} = props;

    const [isOpen, setOpen] = React.useState<any>(false);

    const [checked, setChecked] = React.useState<any>([]);
    const handleToggle = (value: any) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    return (<>
        <Button fullWidth={true} variant={'contained'} color={"primary"} onClick={() => setOpen(true)}>Load Picklist</Button>
        <Dialog
            open={isOpen}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Load Picklist
            </DialogTitle>
            <DialogContent style={{width: '400px', textAlign: 'center'}}>
                <List sx={{width: 350, height: 430, bgcolor: 'background.paper', overflow: 'auto',}} dense
                      component="div" role="list">
                    {filteredLoads.map((value: { id: React.Key | null | undefined; LoadNumber: any; }) => {
                        const labelId = `transfer-list-all-item-${value}-label`;
                        return (
                            // <pre>{JSON.stringify(value)}</pre>
                            <ListItem key={value.id} role="listitem">
                                <ListItemButton role={undefined} onClick={handleToggle(value)} dense>
                                    <ListItemIcon>
                                        <Checkbox
                                            edge="start"
                                            checked={checked.indexOf(value) !== -1}
                                            tabIndex={-1}
                                            disableRipple
                                            // inputProps={{ 'aria-labelledby': labelId }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText id={labelId} primary={`${value.LoadNumber}`}/>
                                </ListItemButton>
                            </ListItem>
                        );
                    })}
                    <ListItem/>
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>Close</Button>
                <Button onClick={() => setOpen(false)}>Print</Button>
            </DialogActions>
        </Dialog>
    </>)
}

export function PickList(props: any) {
    // const {} = props;

    let history = useNavigate();
    const filterFormStructure = [
        { key: "week_year", type: "week-filter", size: {default: 4}, label: "Patching Week", required: true  },
        { key: "week_year_view", type: "header", size: {default: 4}, valueKey: "week_year"  },
    ];

    const filterFormSubject = new Subject();
    const [formFilter, setFormFilter] = React.useState<any>({});
    filterFormSubject.subscribe((n : any) => setFormFilter(n));

    const [loads, setLoads] = React.useState<any>([]);

    const loadRoutes = async () => {
        if (formFilter === undefined || formFilter === null || formFilter['week_year'] === undefined || formFilter['week_year'] === null || formFilter['week_year'] === ""){
            setLoads([]);
            return;
        }
        try {
            let outputRows: any[] = [];
            await formFilter['week_year'].forEachAsync(async (weekObj: { week: any; year: any; }) => {
                console.log(weekObj);
                const response = await axios.get( `${process.env.REACT_APP_ENDPOINT}/api/Loads/${weekObj.week}/${weekObj.year}`);
                if (response.status === 200) {
                    // TODO: refresh the table on the main page? or location.reload
                    console.log(response);
                    outputRows = [...outputRows, ...response.data]
                }
            });
            setLoads(outputRows);
        } catch (err) {
            console.log(err);
        }
    }

    React.useEffect(() => {
        loadRoutes().then();
    }, [formFilter['week_year']]);

    const [expanded, setExpanded] = React.useState<any>(undefined);
    const DAYS_OF_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    return (
        <>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                height: 'calc( 100vh - 100px )',
                width: '100%',
                gap: '1rem'
            }}>
                <div style={{
                    backgroundColor: 'white',
                    height: '5rem',
                    paddingLeft: '0.5rem',
                    paddingTop: "0.25rem"
                }}>
                    <FormPane formStructure={filterFormStructure} formSubject={filterFormSubject}/>
                </div>
                <div style={{paddingLeft: '1rem', paddingRight: '1rem', flexGrow: 1, overflowY: 'scroll'}}>
                    {DAYS_OF_WEEK.map((day_of_week, index) => {
                        let filteredLoads = loads.filter((load : any) => load.day_of_week == index + 1);
                        return (
                            <Accordion key={day_of_week} expanded={expanded === day_of_week}
                                       onChange={() => setExpanded(
                                           expanded === day_of_week ? undefined : day_of_week
                                       )}>
                                <AccordionSummary
                                    // expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1bh-content"
                                    id="panel1bh-header"
                                    style={{
                                        backgroundColor: (day_of_week === expanded) ? '#83AE0D' : (index % 2 === 1) ? '#EBEBEB' : 'white',
                                        color: (day_of_week === expanded) ? 'white' : 'black'
                                    }}
                                >
                                    <Typography sx={{width: '33%', flexShrink: 0}}>
                                        {day_of_week}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div style={{display: 'flex', flexDirection: 'row', gap: '1rem'}}>
                                        <SpeciesPicklistDialog filteredLoads={filteredLoads}/>
                                        <LoadPicklistDialog filteredLoads={filteredLoads}/>
                                        {/*<div style={{ flexGrow: 10 }} />*/}
                                    </div>
                                    {/*<pre>{JSON.stringify(route, undefined, 4)}</pre>*/}
                                    <List>
                                        {filteredLoads.map((load : any) => {
                                            function getDriverName() {
                                                if (load.driver !== null) {
                                                    return `Driver: ${load.driver.name}`
                                                }
                                                return ""
                                            }

                                            function getTruck() {
                                                if (load.truck !== null) {
                                                    return `Truck: ${load.truck.truckNumber}`
                                                }
                                                return ""
                                            }

                                            function getTrailer() {
                                                if (load.trailer !== null) {
                                                    return `Trailer: ${load.trailer.trailerNumber}`
                                                }
                                                return ""
                                            }

                                            let secondaryText = `${getTruck()} ${getTrailer()}`;
                                            let primaryText = `Route: ${load.route.name} Load: ${load.loadNumber} ${getDriverName()}`
                                            return (
                                                <ListItem disablePadding>
                                                    <ListItemButton onClick={() => {
                                                        history(`/shipping/pick_list/${load.id}`)
                                                    }}>
                                                        <ListItemText primary={secondaryText} secondary={primaryText}/>
                                                    </ListItemButton>
                                                </ListItem>
                                            );
                                        })}
                                    </List>
                                </AccordionDetails>
                            </Accordion>
                        );
                    })}
                </div>
                <div style={{display: 'flex', flexDirection: 'row', width: '100%', padding: '1rem', gap: '1rem'}}>

                </div>
            </div>
        </>
    )
}
